import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import { ConfirmationService } from 'primeng/primeng';
var SearchComponent = /** @class */ (function () {
    function SearchComponent(data, dashboardService, errorHandlerService, route, router, confirmationService) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.route = route;
        this.router = router;
        this.confirmationService = confirmationService;
        this.request = false;
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.reqRcmd = { requestTo: {}, requestFrom: {} };
        this.invitereq = { requestTo: {}, requestFrom: {} };
        this.myConnection = [];
        this.query = {};
        this.searchUserRes = [];
        this.sendMsg = false;
        this.viewProfile = {};
        this.msgData = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        //console.log(this.data.storage.myconnection.userid);
    }
    SearchComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SearchComponent.prototype.sendMssage = function (data) {
        this.viewProfile = data;
        this.msgData.usersInTo = [data.userDetailsId];
        this.sendMsg = true;
    };
    SearchComponent.prototype.sendMessage = function () {
        var _this = this;
        this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) { _this.sendMsg = false; console.log(data); }, function (error) {
            _this.handleError(error);
            _this.sendMsg = false;
        });
    };
    SearchComponent.prototype.ngOnInit = function () {
        this.initFn();
    };
    SearchComponent.prototype.initFn = function () {
        var _this = this;
        console.log('inside ngOnInit()');
        this.dashboardService.userSummary1().subscribe(function (data) {
            _this.rating.responseFrom.userDetailsId = data.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = data.userDetailsId;
            _this.invitereq.requestFrom.userDetailsId = data.userDetailsId;
        }, function (error) {
            _this.handleError(error);
        });
        this.route.queryParams.subscribe(function (params) { _this.query.firstName = params['fname'] || null; _this.query.lastName = params['lname'] || null; });
        this.query.baseSearchActionType = "NAME_SEARCH";
        console.log(this.query);
        this.dashboardService.searchUser(this.query).subscribe(function (data) {
            _this.searchUserRes = data;
            if (data.isSearchResultEmpty) {
                _this.confirmationService.confirm({
                    message: "You do not have any friends in your network at the moment. You can invite contacts from your Gmail account to Uvsity " +
                        "and later add them to your list of friends. Would you like to invite contacts from your Gmail account now ?",
                    header: 'Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: function () {
                        _this.router.navigate(['dashboard/addconnections']);
                    },
                    reject: function () {
                        // do nothing
                    }
                });
            }
            console.log(_this.searchUserRes);
        }, function (error) {
            _this.handleError(error);
        });
    };
    SearchComponent.prototype.searchUserLoadMore = function () {
        var _this = this;
        var s3 = this.dashboardService.searchUserLoadMore(this.query).subscribe(function (data) {
            _this.searchUserRes = data;
            if (data.isSearchResultEmpty) {
                _this.createInfoAlert('No more results to display.');
            }
            console.log(_this.searchUserRes);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    SearchComponent.prototype.rcmdReq = function () {
        var _this = this;
        this.reqRcmd.userRequestType = 'RECOMMENDATION_REQUEST';
        console.log(this.reqRcmd);
        this.dashboardService.rcmdRequest(this.reqRcmd).subscribe(function (data) { _this.request = false; }, function (error) {
            _this.handleError(error);
            _this.request = false;
        });
    };
    SearchComponent.prototype.acceptconReq = function (id, searchResult) {
        var _this = this;
        this.dashboardService.connAccept(id).subscribe(function (data) {
            console.log(data);
            searchResult.invitationAction = 'In My Network';
            searchResult.studentsCount = data.requestFrom.studentConnectionCount;
            searchResult.professorsCount = data.requestFrom.professorConnectionCount;
            searchResult.alumniCount = data.requestFrom.alumniConnectionCount;
        }, function (error) {
            _this.handleError(error);
        });
    };
    SearchComponent.prototype.ratingUser = function (searchResult) {
        var _this = this;
        if (this.rating.rating.ratingText == null || this.rating.rating.ratingText == '' || this.rating.rating.ratingText == undefined) {
            this.createInfoAlert("Please select a rating from Best/Fair/Good.");
            return;
        }
        this.showSpinner = true;
        this.rating.userResponseType = 'RATING_RESPONSE';
        console.log(this.rating);
        this.dashboardService.rating(this.rating).subscribe(function (data) {
            console.log(data);
            _this.rating.rating.ratingText = "";
            searchResult.ratingAction = 'RATING_ALREADY_SENT';
            _this.showSpinner = false;
            _this.createInfoAlert("Rating submitted successfully!!");
        }, function (error) {
            _this.handleError(error);
            _this.sendMsg = false;
        });
    };
    SearchComponent.prototype.sendInvite = function (id, searchResult) {
        var _this = this;
        this.invitereq.userRequestText = "Invitation Request sent by User Id " + this.invitereq.requestFrom.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invitereq.userRequestType = 'INVITATION_REQUEST';
        this.invitereq.requestTo.userDetailsId = id;
        console.log(this.invitereq);
        this.dashboardService.sendInvitationReq(this.invitereq).subscribe(function (data) {
            console.log(data);
            searchResult.invitationAction = 'Waiting for Response';
        }, function (error) {
            _this.handleError(error);
        });
    };
    SearchComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    SearchComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return SearchComponent;
}());
export { SearchComponent };
//# sourceMappingURL=search.component.js.map